import {useState} from "react";

export const useMemoryState = <T>(initialState: T, detectChange = ((value: T, oldValue: T): boolean => true)): [T, (newState: T) => void] => {
	const [state, setState] = useState(initialState);
	return [state, (newState: T) => {
		if (newState !== state)
		{
			if (detectChange(newState, state))
			{
				setState(newState);
				console.debug("DX update changed ", state, newState)
			}
		}

		console.debug("DX non changed", state)
	}];
}

export default useMemoryState;